// extracted by mini-css-extract-plugin
export default {"modalWrapper":"DocumentUpload_modalWrapper__P0foW","modalWrapper2":"DocumentUpload_modalWrapper2__dDVAa","loader":"DocumentUpload_loader__sV6hV","l3":"DocumentUpload_l3__w-QWX"};